import * as React from 'react';
import { AlertCircle, ExternalLink, X } from 'lucide-react';
import type { UsageLimitErrorData } from '../../utils/usageLimitError';
import { webAppPathUrl } from '../../utils/webAppBaseUrl';
import { openExternalUrl } from '../../utils/openExternalUrl';
import './AnalyzeAgainModal.css';
import './UsageLimitModal.css';

interface UsageLimitModalProps {
  isOpen: boolean;
  onClose: () => void;
  errorData: UsageLimitErrorData | null;
}

export const UsageLimitModal: React.FC<UsageLimitModalProps> = ({
  isOpen,
  onClose,
  errorData,
}) => {
  if (!isOpen || !errorData) return null;

  const handleViewUsage = () => {
    openExternalUrl(webAppPathUrl(errorData.usage_page_url || '/account/usage'));
    onClose();
  };

  return (
    <div
      className="aa-modal-backdrop usage-limit-modal-backdrop"
      role="presentation"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="aa-modal usage-limit-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="usage-limit-modal-title"
      >
        <div className="aa-modal-header">
          <div className="aa-modal-icon-wrap usage-limit-modal-icon-wrap">
            <AlertCircle className="usage-limit-modal-icon" aria-hidden />
          </div>
          <div className="aa-modal-header-text">
            <h2 id="usage-limit-modal-title" className="aa-modal-title">
              Usage Limit Exceeded
            </h2>
            <p className="aa-modal-subtitle">Monthly cost limit reached</p>
          </div>
          <button
            type="button"
            className="aa-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        <div className="usage-limit-modal-body">
          <p>{errorData.message}</p>
          <p className="usage-limit-modal-action">{errorData.action_required}</p>
        </div>

        <div className="aa-modal-actions usage-limit-modal-actions">
          <button type="button" className="aa-btn-primary" onClick={handleViewUsage}>
            <ExternalLink size={16} aria-hidden />
            View Usage Details
          </button>
          <button type="button" className="aa-btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
